import React, { useEffect, useState } from 'react';
import { Typography, Row, Col, Select } from 'antd';
import { useSearchParams } from "react-router-dom";

import usePlayerList from "hooks/usePlayerList";
import usePlayerStats from "hooks/usePlayerStats";

import { Loading } from 'components';
import { useChangePageTitle } from 'utils/useChangePageTitle';

import ComparisonStats from './ComparisonStats';
import LoggedInGuard from 'wrappers/LoggedInGuard';

const { Text } = Typography;

const PlayerStats = () => {

    const [searchParams] = useSearchParams();
    const changePageTitle = useChangePageTitle();

    const queryPlayerId = Number(searchParams.get('playerId')) || undefined;

    const [initialPlayerId, setInitialPlayerId] = useState(queryPlayerId);
    const [comparisonPlayerId, setComparisonPlayerId] = useState(undefined);

    const { playerList, playerListLoading } = usePlayerList();
    const {
        player: initialPlayer,
        stats: initialPlayerStats,
        recentResults: initialPlayerResults,
    } = usePlayerStats(initialPlayerId);

    const {
        player: comparisonPlayer,
        stats: comparisonPlayerStats,
        recentResults: comparisonPlayerResults,
    } = usePlayerStats(comparisonPlayerId);

    useEffect(() => {
        changePageTitle('Player Comparison');
    }, [])

    if (playerListLoading) {
        return <Loading />
    }

    const buildOptions = (excludeId) => playerList.map(position => ({
        label: position.positionName,
        options: position.players
            .filter(player => String(player.id) !== String(excludeId))
            .map(player => ({ label: player.name, value: player.id })),
    }));

    return (
        <LoggedInGuard userMustBePremium={true}>
            <Row gutter={[16, 16]} align="top" style={{ marginBottom: 24 }}>
                <Col xs={12} md={11}>
                    <Select
                        showSearch={{ optionFilterProp: 'label' }}
                        allowClear
                        placeholder="Select a player"
                        style={{ width: '100%', marginBottom: 12 }}
                        value={initialPlayerId}
                        onChange={(id) => setInitialPlayerId(id)}
                        options={buildOptions(comparisonPlayerId)}
                        />
                </Col>

                <Col xs={0} md={2} style={{ textAlign: 'center', paddingTop: 6 }}>
                    <Text type="secondary">vs</Text>
                </Col>

                <Col xs={12} md={11}>
                    <Select
                        showSearch={{ optionFilterProp: 'label' }}
                        allowClear
                        placeholder="Select a player"
                        style={{ width: '100%', marginBottom: 12 }}
                        value={comparisonPlayerId}
                        onChange={(id) => setComparisonPlayerId(id)}
                        options={buildOptions(initialPlayerId)}
                        />
                </Col>
            </Row>

            <ComparisonStats
                initialPlayer={initialPlayer}
                initialPlayerStats={initialPlayerStats}
                initialPlayerResults={initialPlayerResults}
                comparisonPlayer={comparisonPlayer}
                comparisonPlayerStats={comparisonPlayerStats}
                comparisonPlayerResults={comparisonPlayerResults}
                />
        </LoggedInGuard>
    )
}

export default PlayerStats;
